import { PRICE_SCENARIOS } from "@circle-react/helpers/paywallPriceHelpers";
import type { PaywallCheckoutPreview } from "@circle-react/types";
import { noop } from "lodash";

import { t } from "@/i18n-js/instance";

import type { PreviewComponents } from "../../../types";
import { Lines } from "../Lines";
import { hideWhenItIsFreeTrial } from "./helpers";

export const subscriptionVariants: PreviewComponents = [
  [
    Lines.TodayPaymentLine,
    (preview: PaywallCheckoutPreview) => {
      if (
        [
          PRICE_SCENARIOS.trialThenValue,
          PRICE_SCENARIOS.trialThenUpfrontThenValue,
        ].includes(preview.preview_scenario)
      ) {
        return {
          label: t("paywall_checkout.todays_payment"),
          value: null,
        };
      }

      return {
        label: t("paywall_checkout.todays_payment"),
      };
    },
  ],
  [Lines.FreeTrialLine, noop],
  [Lines.SubtotalLine, hideWhenItIsFreeTrial],
  [Lines.DiscountLine, hideWhenItIsFreeTrial],
  [Lines.TaxLine, hideWhenItIsFreeTrial],
  [Lines.EndingBalanceLine, hideWhenItIsFreeTrial],
  [Lines.TotalDueTodayLine, hideWhenItIsFreeTrial],
];
